import { RatingLevel } from '@core/interview-results-types';

export const getRatingName = (rating: number): RatingLevel => {
  if (rating <= 25) {
    return RatingLevel.No;
  } else if (rating <= 50) {
    return RatingLevel.Neutral;
  } else if (rating <= 75) {
    return RatingLevel.Yes;
  } else {
    return RatingLevel.StrongYes;
  }
};
